/**
 * Generates the anonymized filename by inserting "_anonimizado" before the extension
 * Examples:
 *   "document.pdf" -> "document_anonimizado.pdf"
 *   "report.docx" -> "report_anonimizado.docx"
 *   "file.name.xlsx" -> "file.name_anonimizado.xlsx"
 *   "noext" -> "noext_anonimizado"
 */
export function getAnonymizedFilename(originalFilename: string): string {
  const lastDotIndex = originalFilename.lastIndexOf('.');

  if (lastDotIndex === -1 || lastDotIndex === 0) {
    // No extension or hidden file like ".gitignore"
    return `${originalFilename}_anonimizado`;
  }

  const nameWithoutExt = originalFilename.substring(0, lastDotIndex);
  const extension = originalFilename.substring(lastDotIndex);

  return `${nameWithoutExt}_anonimizado${extension}`;
}
